export default __webpack_public_path__ + "static/media/clinic13.af107001.jpg";